/* VNSTRA rekenhulp - berekent het aantal vellen folie. Geen library. */
(function () {
  function init(root) {
    var area = parseFloat(root.getAttribute('data-vnstra-area'));
    if (!area || area <= 0) area = 1.22;
    var unit = parseFloat(root.getAttribute('data-vnstra-price'));
    var currency = root.getAttribute('data-vnstra-currency') || '';
    var b = root.querySelector('[data-vnstra-breedte]');
    var h = root.querySelector('[data-vnstra-hoogte]');
    var d = root.querySelector('[data-vnstra-deurtjes]');
    var num = root.querySelector('[data-vnstra-num]');
    var txt = root.querySelector('[data-vnstra-txt]');
    var note = root.querySelector('[data-vnstra-note]');
    if (!b || !h || !d || !num || !txt) return;

    function money(cents) {
      return currency + ' ' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function calc(fromUser) {
      var bv = parseFloat(b.value);
      var hv = parseFloat(h.value);
      var dv = parseFloat(d.value);
      if (!(bv > 0 && hv > 0 && dv > 0)) {
        num.textContent = '';
        txt.textContent = '';
        if (note) note.textContent = '';
        return;
      }
      var m2 = (bv / 100) * (hv / 100) * dv;
      var vellen = Math.ceil((m2 * 1.10) / area);
      num.textContent = String(vellen);
      txt.textContent = (vellen === 1 ? 'vel' : 'vellen') + ', inclusief 10% reserve';
      if (note) {
        var s = 'Je meet ongeveer ' + m2.toFixed(2).replace('.', ',') + ' m².';
        if (unit > 0) { s += ' Ongeveer ' + money(unit * vellen) + ' aan folie.'; }
        note.textContent = s;
      }
      if (fromUser) try { sessionStorage.setItem('vnstraRekenhulp', JSON.stringify({ vellen: vellen, deurtjes: dv })); } catch (e) {}
    }

    b.addEventListener('input', function () { calc(true); });
    h.addEventListener('input', function () { calc(true); });
    d.addEventListener('input', function () { calc(true); });
    calc();
  }
  function boot() {
    var nodes = document.querySelectorAll('[data-vnstra-rekenhulp]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
